import styled from 'styled-components';

const Input = styled.input`
  padding: 0.75rem 1rem;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  border-radius: 8px;
  font-size: 1rem;
`;

export default Input;
